import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// 앱 전역 토스트 스타일 — index.css 다음에 와야 한다(뒤에 오는 쪽이 동일 특이도에서 이김).
import "./styles/toast.css";
import App from "./App";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {CssBaseline, ThemeProvider} from "@mui/material";
// MUI 전역 테마는 muiTheme(styles/muiTheme.js) 하나만 쓴다 — 구 theme.js(토스풍)는 제거됨.
import { muiTheme } from "./styles/designSystem";
import "pretendard/dist/web/static/pretendard.css";
import {ToastContainer} from "react-toastify";
import { ConfirmDialogHost, NotifyDialogHost } from "./util/confirmDialog";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ThemeProvider theme={muiTheme}>
        <CssBaseline />
        {/* ✅ 토스트는 앱 전체 1개만 */}
        <ToastContainer
            position="top-center"
            autoClose={2500}
            hideProgressBar
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable={false}
            theme="light"
            style={{ zIndex: 999999 }}
        />
        {/* ✅ confirm/notify 다이얼로그 호스트 — confirm()/notify() 유틸이 이 호스트를 통해 표시 */}
        <ConfirmDialogHost />
        <NotifyDialogHost />
        <App />
    </ThemeProvider>
);
